import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_PREVENTIVE_TASK_ASSIGNEE,
  CLEAR_PREVENTIVE_TASK_ASSIGNEES,
  FLAG_GETTING_PREVENTIVE_TASK_ASSIGNEES,
  FLAG_PREVENTIVE_TASK_ASSIGNEE_ACTIVITY,
  GET_PREVENTIVE_TASK_ASSIGNEE,
  GET_PREVENTIVE_TASK_ASSIGNEES,
} from '../../../actions/types/task-schedule';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_PREVENTIVE_TASK_ASSIGNEES:
      return state.setIn(['all', 'loading'], payload);

    case GET_PREVENTIVE_TASK_ASSIGNEES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_PREVENTIVE_TASK_ASSIGNEES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_PREVENTIVE_TASK_ASSIGNEE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_PREVENTIVE_TASK_ASSIGNEE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_PREVENTIVE_TASK_ASSIGNEE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    default:
      return state;
  }
};
